<template>
  <div class="switcher">
    <input
      :id="id"
      v-model="isChecked"
      type="checkbox"
      class="switch"
      :class="{ 'pseudo-disable': isPseudoDisabled }"
      v-bind="$attrs"
      :title="title"
      :disabled="isDisabled"
      v-on="listeners"
    />
    <label v-if="label" :for="id"> {{ label }} </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    isCheckedInitial: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
    },
    isPseudoDisabled: {
      type: Boolean,
    }
  },
  data() {
    return {
      isChecked: this.isCheckedInitial,
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        change: (e) => {
          e.preventDefault();
          this.$emit('input', this.isChecked);
        },
      }
    },
  },
  methods: {
    resetSwitcher() {
      this.isChecked = this.isCheckedInitial
    }
  },
}
</script>

<style lang="scss" scoped>
// stylelint-disable
.switcher {
  input[type='checkbox'] {
    --active: #007aff;
    --active-inner: #fff;
    --focus: 1px rgba(39, 94, 254, 0.3);
    --border: #bbc1e1;
    --border-hover: #007aff;
    --background: #fff;
    --disabled: #f6f8ff;
    --disabled-inner: #e1e6f9;

    position: relative;
    display: inline-block;
    height: 21px;
    margin: 0;
    vertical-align: top;
    cursor: pointer;
    background: var(--b, var(--background));
    border: 1px solid var(--bc, var(--border));
    outline: none;
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
    -webkit-appearance: none;
    -moz-appearance: none;
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: '';
      transition: transform var(--d-t, 0.3s) var(--d-t-e, ease), opacity var(--d-o, 0.2s);
    }
    &:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: 0.3s;
      --d-t: 0.6s;
      --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
    }
    &:disabled,
    &.pseudo-disable {
      --b: var(--disabled);

      cursor: not-allowed;
      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }
      & + label {
        cursor: not-allowed;
      }
    }
    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          --bc: var(--border-hover);
        }
      }
    }
    &:not(.switch) {
      width: 21px;
      &::after {
        opacity: var(--o, 0);
      }
      &:checked {
        --o: 1;
      }
    }
    & + label {
      display: inline-block;
      margin-left: 4px;
      font-size: 14px;
      line-height: 21px;
      vertical-align: top;
      cursor: pointer;
    }

    &:not(.switch) {
      border-radius: 7px;
      &::after {
        top: 4px;
        left: 7px;
        width: 5px;
        height: 9px;
        border: 2px solid var(--active-inner);
        border-top: 0;
        border-left: 0;
        transform: rotate(var(--r, 20deg));
      }
      &:checked {
        --r: 43deg;
      }
    }
    &.switch {
      width: 38px;
      border-radius: 11px;
      &::after {
        top: 2px;
        left: 2px;
        width: 15px;
        height: 15px;
        background: var(--ab, var(--border));
        border-radius: 50%;
        transform: translateX(var(--x, 0));
      }
      &:checked {
        --ab: var(--active-inner);
        --x: 17px;
      }
      &:disabled {
        &:not(:checked) {
          &::after {
            opacity: 0.6;
          }
        }
      }
    }
  }
}
</style>
